"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateInventoryAudit = void 0;
const mobx_1 = require("mobx");
const audit_product_1 = require("./audit-product");
class CreateInventoryAudit {
    constructor(json) {
        this.title = '';
        this.mappedProducts = new Map();
        this.getAuditProduct = (productId) => this.mappedProducts.get(productId);
        this.addAuditProduct = (auditProduct) => {
            const existingAuditProductRecord = this.getAuditProduct(auditProduct.productId);
            if (existingAuditProductRecord) {
                return existingAuditProductRecord;
            }
            const newAuditProductRecord = new audit_product_1.EditAuditProduct(auditProduct);
            this.mappedProducts.set(auditProduct.productId, newAuditProductRecord);
            return newAuditProductRecord;
        };
        this.addAuditBulkProducts = (audit) => {
            const bulkProducts = new Map();
            audit.products.forEach((auditProduct) => {
                const newAuditProductRecord = new audit_product_1.EditAuditProduct(auditProduct);
                bulkProducts.set(auditProduct.productId, newAuditProductRecord);
            });
            // Keep the current product if it exist
            this.mappedProducts = new Map([...bulkProducts, ...this.mappedProducts]);
        };
        this.removeAuditProduct = (productId) => {
            this.mappedProducts.delete(productId);
        };
        this.removeAllAuditProducts = () => {
            this.mappedProducts = new Map();
        };
        this.populate(json);
    }
    populate(json) {
        const { products } = json, restOfJson = __rest(json, ["products"]);
        Object.assign(this, restOfJson);
        products.forEach((p) => this.mappedProducts.set(p.productId, new audit_product_1.EditAuditProduct(p)));
    }
    get products() {
        return [...this.mappedProducts.values()];
    }
}
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "title", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "companyId", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "locationId", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "locationName", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "startingUserId", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "startingUserName", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "endingUserId", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "endingUserName", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "notes", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "createDate", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "updateDate", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "completeDate", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "inventorySnapshotId", void 0);
__decorate([
    mobx_1.observable
], CreateInventoryAudit.prototype, "mappedProducts", void 0);
__decorate([
    mobx_1.action
], CreateInventoryAudit.prototype, "populate", null);
__decorate([
    mobx_1.action
], CreateInventoryAudit.prototype, "addAuditProduct", void 0);
__decorate([
    mobx_1.action
], CreateInventoryAudit.prototype, "addAuditBulkProducts", void 0);
__decorate([
    mobx_1.action
], CreateInventoryAudit.prototype, "removeAuditProduct", void 0);
__decorate([
    mobx_1.action
], CreateInventoryAudit.prototype, "removeAllAuditProducts", void 0);
__decorate([
    mobx_1.computed
], CreateInventoryAudit.prototype, "products", null);
exports.CreateInventoryAudit = CreateInventoryAudit;
//# sourceMappingURL=audit.js.map